module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/login/password-recovery/password-recovery.component.scss
// module id = ./src/app/routes/login/password-recovery/password-recovery.component.scss
// module chunks = 9